import { Chip } from '@mui/material';
import { isLightColor } from '../../Leads/DynamicFormFields/helper.ts';

const CommonBadges = ({
  pill = true,
  color = 'primary',
  value = '-',
  style = {
    whiteSpace: 'unset',
    textTransform: 'none',
  },
  variant = 'filled',
  onDelete = undefined,
  showDelete = false,
  icon = undefined, // 👈 custom right-side icon (can have events)
}) => {
  const isPaletteColor = ['primary', 'secondary', 'error', 'info', 'success', 'warning'].includes(
    color
  );

  const isHexColor = typeof color === 'string' && color.startsWith('#') && color.length === 7;
  const textColor = isHexColor ? (isLightColor(color) ? '#000' : '#fff') : undefined;

  const chipProps = {
    color: isPaletteColor ? color : 'default',
    variant,
    size: 'small',
    sx: {
      backgroundColor: !isPaletteColor ? color : undefined,
      color: !isPaletteColor ? textColor : undefined,
      borderRadius: pill ? '9999px' : '4px',
      ...style,
    },
    ...(showDelete && onDelete && { onDelete }),
    label: (
      <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        {value}
        {icon && <span style={{ display: 'flex' }}>{icon}</span>}
      </span>
    ),
  };

  return <Chip {...chipProps} />;
};

export default CommonBadges;



// import { Chip } from '@mui/material';
// import { isLightColor } from '../../Leads/DynamicFormFields/helper.ts';

// const CommonBadges = ({
//   pill = true,
//   color = 'primary',
//   value = '-',
//   style = {
//     whiteSpace: 'unset',
//     textTransform: 'uppercase',
//     // fontSize: '10px',
//   },
//   variant = 'filled',
//   onDelete = undefined,
//   showDelete = false,
//   icon = undefined,
// }) => {
//   const isPaletteColor = ['primary', 'secondary', 'error', 'info', 'success', 'warning'].includes(
//     color
//   );

//   const isHexColor = typeof color === 'string' && color.startsWith('#') && color.length === 7;
//   const textColor = isHexColor ? (isLightColor(color) ? '#000' : '#fff') : undefined;

//   // Only pass onDelete if it exists and showDelete is true
//   const chipProps = {
//     label: value,
//     color: isPaletteColor ? color : 'default',
//     variant,
//     size: 'small',
//     sx: {
//       backgroundColor: !isPaletteColor ? color : undefined,
//       color: !isPaletteColor ? textColor : undefined,
//       borderRadius: pill ? '9999px' : '4px',
//       ...style,
//     },
//     icon,
//     ...(showDelete && onDelete && { onDelete }),
//   };

//   return <Chip {...chipProps} />;
// };

// export default CommonBadges;

